module.exports = __webpack_public_path__ + "static/media/redline-logo.7c2dcc2b.png";